import { Tag } from "@app/types/Cue";
import elevenThumbnail from "@assets/mybt/illustrations/7-eleven.png";
import aseanThumbnail from "@assets/mybt/illustrations/asean.png";
import ausieThumbnail from "@assets/mybt/illustrations/australia.png";
import aussieSThumbnail from "@assets/mybt/illustrations/australia-new-zealand-stocks.png";
import bankThumbnail from "@assets/mybt/illustrations/bank-of-singapore.png";
import bondsThumbnail from "@assets/mybt/illustrations/bonds.png";
import canadaThumbnail from "@assets/mybt/illustrations/canada.png";
import chinaThumbnail from "@assets/mybt/illustrations/china.png";
import chinaEThumbnail from "@assets/mybt/illustrations/china-economy.png";
import chinaSThumbnail from "@assets/mybt/illustrations/china-stocks.png";
import climateThumbnail from "@assets/mybt/illustrations/climate-change.png";
import covidThumbnail from "@assets/mybt/illustrations/covid-19.png";
import cryptoThumbnail from "@assets/mybt/illustrations/cryptocurrencies.png";
import currenciesThumbnail from "@assets/mybt/illustrations/currencies.png";
import electricThumbnail from "@assets/mybt/illustrations/electric-vehicles.png";
import europeSThumbnail from "@assets/mybt/illustrations/europe-stocks.png";
import europeanThumbnail from "@assets/mybt/illustrations/european-union.png";
import financialResultThumbnail from "@assets/mybt/illustrations/financial-results.png";
import hkThumbnail from "@assets/mybt/illustrations/hong-kong.png";
import HKSThumbnail from "@assets/mybt/illustrations/hong-kong-stocks.png";
import housingThumbnail from "@assets/mybt/illustrations/housing.png";
import indiaThumbnail from "@assets/mybt/illustrations/india.png";
import indo1Thumbnail from "@assets/mybt/illustrations/indonesia (1).png";
import indonesiaThumbnail from "@assets/mybt/illustrations/indonesia.png";
import inflationThumbnail from "@assets/mybt/illustrations/inflation.png";
import interestThumbnail from "@assets/mybt/illustrations/interest-rates.png";
import japanThumbnail from "@assets/mybt/illustrations/japan.png";
import japanSThumbnail from "@assets/mybt/illustrations/japan-stocks.png";
import maThumbnail from "@assets/mybt/illustrations/m-a.png";
import malaysia1Thumbnail from "@assets/mybt/illustrations/malaysia (1).png";
import malaysiaThumbnail from "@assets/mybt/illustrations/malaysia.png";
import malayiaSThumbnail from "@assets/mybt/illustrations/malaysia-stocks.png";
import metalsThumbnail from "@assets/mybt/illustrations/metals.png";
import oilThumbnail from "@assets/mybt/illustrations/oil-prices.png";
import opecThumbnail from "@assets/mybt/illustrations/opec.png";
import russ1Thumbnail from "@assets/mybt/illustrations/russia (1).png";
import russiaThumbnail from "@assets/mybt/illustrations/russia.png";
import semiThumbnail from "@assets/mybt/illustrations/semiconductors.png";
import singaporeEThumbnail from "@assets/mybt/illustrations/singapore-economy.png";
import singaporeSThumbnail from "@assets/mybt/illustrations/singapore-stocks.png";
import sokorThumbnail from "@assets/mybt/illustrations/south-korea.png";
import straitsSThumbnail from "@assets/mybt/illustrations/straits-times-index.png";
import sustainabilityThumbnail from "@assets/mybt/illustrations/sustainability.png";
import thailandThumbnail from "@assets/mybt/illustrations/thailand.png";
import UKEThumbnail from "@assets/mybt/illustrations/uk-economy.png";
import UKThumbnail from "@assets/mybt/illustrations/united-kingdom.png";
import USThumbnail from "@assets/mybt/illustrations/united-states.png";
import USEThumbnail from "@assets/mybt/illustrations/us-economy.png";
import usThumbnail from "@assets/mybt/illustrations/us-federal-reserve.png";
import USSThumbnail from "@assets/mybt/illustrations/us-stocks.png";
import yenThumbnail from "@assets/mybt/illustrations/yen.png";

export const myBTRecommendedKeywords: Tag[] = [
  {
    name: "Financial Results",
    urlPath: "/keywords/financial-results",
    thumbnail: financialResultThumbnail,
  },
  {
    name: "Inflation",
    urlPath: "/keywords/inflation",
    thumbnail: inflationThumbnail,
  },
  {
    name: "Cryptocurrencies",
    urlPath: "/keywords/cryptocurrencies",
    thumbnail: cryptoThumbnail,
  },
  {
    name: "Covid-19",
    urlPath: "/keywords/covid-19",
    thumbnail: covidThumbnail,
  },
  {
    name: "Interest Rates",
    urlPath: "/keywords/interest-rates",
    thumbnail: interestThumbnail,
  },
  {
    name: "Electric Vehicles",
    urlPath: "/keywords/electric-vehicles",
    thumbnail: electricThumbnail,
  },
  { name: "Canada", urlPath: "/keywords/canada", thumbnail: canadaThumbnail },
  {
    name: "Climate Change",
    urlPath: "/keywords/climate-change",
    thumbnail: climateThumbnail,
  },
  {
    name: "Currencies",
    urlPath: "/keywords/currencies",
    thumbnail: currenciesThumbnail,
  },
  {
    name: "Semiconductors",
    urlPath: "/keywords/semiconductors",
    thumbnail: semiThumbnail,
  },
  {
    name: "Housing",
    urlPath: "/keywords/housing",
    thumbnail: housingThumbnail,
  },
  { name: "M&A", urlPath: "/keywords/ma", thumbnail: maThumbnail },
  { name: "Bonds", urlPath: "/keywords/bonds", thumbnail: bondsThumbnail },
  {
    name: "Sustainability",
    urlPath: "/keywords/sustainability",
    thumbnail: sustainabilityThumbnail,
  },
  {
    name: "Oil Prices",
    urlPath: "/keywords/oil-prices",
    thumbnail: oilThumbnail,
  },
  {
    name: "US Federal Reserve",
    urlPath: "/keywords/us-federal-reserve",
    thumbnail: usThumbnail,
  },
  { name: "Opec", urlPath: "/keywords/opec", thumbnail: opecThumbnail },
  { name: "Russia", urlPath: "/keywords/russia", thumbnail: russiaThumbnail },
  { name: "Metals", urlPath: "/keywords/metals", thumbnail: metalsThumbnail },
  { name: "Yen", urlPath: "/keywords/yen", thumbnail: yenThumbnail },
  {
    name: "Malaysia",
    urlPath: "/keywords/malaysia",
    thumbnail: malaysiaThumbnail,
  },
  {
    name: "7-eleven",
    urlPath: "/keywords/7-eleven",
    thumbnail: elevenThumbnail,
  },
] as Tag[];

export const myBTRegionsKeywords: Tag[] = [
  {
    name: "China",
    urlPath: "/keywords/china",
    thumbnail: chinaThumbnail,
  },
  {
    name: "United States",
    urlPath: "/keywords/united-states",
    thumbnail: USThumbnail,
  },
  {
    name: "United Kingdom",
    urlPath: "/keywords/united-kingdom",
    thumbnail: UKThumbnail,
  },
  {
    name: "US Economy",
    urlPath: "/keywords/us-economy",
    thumbnail: USEThumbnail,
  },
  {
    name: "Japan",
    urlPath: "/keywords/japan",
    thumbnail: japanThumbnail,
  },
  {
    name: "Bank of Singapore",
    urlPath: "/keywords/bank-of-singapore",
    thumbnail: bankThumbnail,
  },
  {
    name: "Australia",
    urlPath: "/keywords/australia",
    thumbnail: ausieThumbnail,
  },
  {
    name: "South Korea",
    urlPath: "/keywords/south-korea",
    thumbnail: sokorThumbnail,
  },
  {
    name: "Indonesia",
    urlPath: "/keywords/indonesia",
    thumbnail: indo1Thumbnail,
  },
  {
    name: "Hong Kong",
    urlPath: "/keywords/hong-kong",
    thumbnail: hkThumbnail,
  },
  {
    name: "India",
    urlPath: "/keywords/india",
    thumbnail: indiaThumbnail,
  },
  {
    name: "Russia",
    urlPath: "/keywords/russia",
    thumbnail: russ1Thumbnail,
  },
  {
    name: "China Economy",
    urlPath: "/keywords/china-economy",
    thumbnail: chinaEThumbnail,
  },
  {
    name: "UK Economy",
    urlPath: "/keywords/uk-economy",
    thumbnail: UKEThumbnail,
  },
  {
    name: "Malaysia",
    urlPath: "/keywords/malaysia",
    thumbnail: malaysia1Thumbnail,
  },
  {
    name: "European Union",
    urlPath: "/keywords/european-union",
    thumbnail: europeanThumbnail,
  },
  {
    name: "Thailand",
    urlPath: "/keywords/thailand",
    thumbnail: thailandThumbnail,
  },
  {
    name: "Asean",
    urlPath: "/keywords/asean",
    thumbnail: aseanThumbnail,
  },
  {
    name: "Singapore Economy",
    urlPath: "/keywords/singapore-economy",
    thumbnail: singaporeEThumbnail,
  },
] as Tag[];

export const myBTStocksKeywords: Tag[] = [
  {
    name: "China stocks",
    urlPath: "/keywords/china-stocks",
    thumbnail: chinaSThumbnail,
  },
  {
    name: "Singapore Stocks",
    urlPath: "/keywords/singapore-stocks",
    thumbnail: singaporeSThumbnail,
  },
  {
    name: "Hong Kong stocks",
    urlPath: "/keywords/hong-kong-stocks",
    thumbnail: HKSThumbnail,
  },
  {
    name: "Europe Stocks",
    urlPath: "/keywords/europe-stocks",
    thumbnail: europeSThumbnail,
  },
  {
    name: "Japan stocks",
    urlPath: "/keywords/japan-stocks",
    thumbnail: japanSThumbnail,
  },
  {
    name: "Malaysia stocks",
    urlPath: "/keywords/malaysia-stocks",
    thumbnail: malayiaSThumbnail,
  },
  {
    name: "Australia/New Zealand stocks",
    urlPath: "/keywords/australianew-zealand-stocks",
    thumbnail: aussieSThumbnail,
  },
  {
    name: "US stocks",
    urlPath: "/keywords/us-stocks",
    thumbnail: USSThumbnail,
  },
  {
    name: "Straits Times Index",
    urlPath: "/keywords/straits-times-index",
    thumbnail: straitsSThumbnail,
  },
  {
    name: "Indonesia",
    urlPath: "/keywords/indonesia",
    thumbnail: indonesiaThumbnail,
  },
] as Tag[];

export const myBTTagsDefinedList: {
  name: "recommended" | "stocks" | "regions";
  label: string;
  tags: Tag[];
}[] = [
  {
    name: "recommended",
    label: "Recommended",
    tags: myBTRecommendedKeywords,
  },
  {
    name: "stocks",
    label: "Stocks",
    tags: myBTStocksKeywords,
  },
  {
    name: "regions",
    label: "Region",
    tags: myBTRegionsKeywords,
  },
];
